// OK-71: Search hidden until the global search/command palette ships.
// import { Search } from "lucide-react";
import { BrandMark } from "@/components/layout/brand-mark";
import { ContextBreadcrumb } from "@/components/layout/context-breadcrumb";
import { NotificationButton } from "@/components/layout/notification-button";
import { WeatherButton } from "@/components/layout/weather-button";
import { SidebarTrigger } from "@/components/ui/sidebar";

export function AppHeader() {
	return (
		<header className="app-header">
			<div className="app-header__brand">
				<SidebarTrigger className="app-header__menu-toggle" />
				<BrandMark />
			</div>

			<div className="app-header__main">
				<ContextBreadcrumb />

				{/* OK-71: search field hidden until the global search / command
				    palette ships (originally out of scope for OB-6, header field only). */}
				{/* <div className="app-search">
					<Search className="app-search__icon" />
					<input
						type="search"
						aria-label="Buscar"
						placeholder="Buscar relatos, materiais, requisições..."
						className="app-search__input"
					/>
					<kbd className="app-search__kbd">⌘K</kbd>
				</div> */}

				<div className="app-header__spacer" />

				<div className="app-header__actions">
					<WeatherButton />
					<NotificationButton />
				</div>
			</div>
		</header>
	);
}
